export default function (state) {
  return state.list.reduce((sum,i)=>{
    return sum + i.sum;
  },0)
}